export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="box-border flex flex-col items-center p-4 gap-12 w-full h-full bg-[#FEFEFE] flex-grow">
      <div className="flex flex-col items-center gap-6 w-full h-full max-w-full">
        {children}
      </div>
    </div>
  );
}
